module.exports = __webpack_public_path__ + "static/media/between_the_book.ccfc4c1e.png";